var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-list"},[_c('CommonList',{ref:"commonList",staticStyle:{"padding-bottom":"50px","overflow":"auto"},attrs:{"type":"invoice","selectTypeFilter":_vm.selectTypeFilter},on:{"edit":_vm.onEdit}}),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }